import React, { Component } from "react";
import { connect } from "react-redux";
import { usrRole } from "../../utils/dataUtil";
import { Card, Select, message, Input, Table, Button } from "antd";
import {
  req_list_ssp_target_principal,
  req_add_ssp_worker,
  req_multiple_employee,
} from "../../api";
import { getSSPAcademicYear } from "../../utils/dateUtil";
const { Search } = Input;
const { Option } = Select;

class ManageWorkerAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {};

  state = {
    row: {
      Gid: "",
      PlanAcademicYear: getSSPAcademicYear(new Date()),
      EducationalSystemTwName: "四技",
      CollegeCode: "",
      CollegeFullName: "",
      DeptmentCode: "",
      DeptmentRealCode: "",
      DeptmentFullName: "",
      DeptmentPlannerCode: "",
    },
    academicSystems: [
      { label: "四技", value: "四技" },
      { label: "七技", value: "七技" },
      { label: "二技", value: "二技" },
    ],
    colleges: [
      // { label: "管理學院", value: "59" },
      { label: "民生暨管理學院", value: "60" },
      { label: "設計學院", value: "62" },
      { label: "藝術學院", value: "63" },
      // { label: "旅遊學院", value: "193" },
    ],
    targetdeparts: [
      { value: "187", label: "應用英語系", group: "60" },
      { value: "196", label: "旅館管理系", group: "60" },
      { value: "214", label: "養生休閒管理系", group: "60" },
      { value: "161", label: "企業管理系", group: "60" },
      { value: "24", label: "資訊管理系", group: "60" },
      { value: "7", label: "國際企業經營系", group: "60" },
      { value: "8", label: "財務金融系", group: "60" },
      { value: "165", label: "餐飲系", group: "60" },
      { value: "178", label: "生活服務產業系", group: "60" },
      { value: "199", label: "運動休閒與健康管理系", group: "60" },
      { value: "3", label: "服飾設計管理系", group: "60" },
      { value: "4", label: "美容造型設計系", group: "60" },
      { value: "5", label: "幼兒保育系", group: "60" },
      { value: "11", label: "室內設計系", group: "62" },
      { value: "159", label: "時尚設計系", group: "62" },
      { value: "164", label: "多媒體動畫系", group: "62" },
      { value: "17", label: "視覺傳達設計系", group: "62" },
      { value: "18", label: "商品設計系", group: "62" },
      { value: "212", label: "漫畫系", group: "63" },
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
      { value: "213", label: "流行音樂系", group: "63" },
    ],
    alldeparts: [
      {
        value: "187",
        label: "應用英語系",
        group: "193",
        academicSystem: "四技",
        deptmentCode: "D5450",
      },
      {
        value: "196",
        label: "旅館管理系",
        group: "193",
        academicSystem: "四技",
        deptmentCode: "D5510",
      },
      {
        value: "214",
        label: "養生休閒管理系",
        group: "193",
        academicSystem: "四技",
        deptmentCode: "D5490",
      },
      {
        value: "161",
        label: "企業管理系",
        group: "59",
        academicSystem: "四技",
        deptmentCode: "D2360",
      },
      {
        value: "24",
        label: "資訊管理系",
        group: "59",
        academicSystem: "四技",
        deptmentCode: "D2220",
      },
      {
        value: "7",
        label: "國際企業經營系",
        group: "59",
        academicSystem: "四技",
        deptmentCode: "D2180",
      },
      {
        value: "8",
        label: "財務金融系",
        group: "59",
        academicSystem: "四技",
        deptmentCode: "D2100",
      },
      {
        value: "165",
        label: "餐飲系",
        group: "60",
        academicSystem: "四技",
        deptmentCode: "D1340",
      },
      {
        value: "178",
        label: "生活服務產業系",
        group: "60",
        academicSystem: "四技",
        deptmentCode: "D1400",
      },
      {
        value: "199",
        label: "運動休閒與健康管理系",
        group: "60",
        academicSystem: "四技",
        deptmentCode: "D1520",
      },
      {
        value: "3",
        label: "服飾設計管理系",
        group: "60",
        academicSystem: "四技",
        deptmentCode: "D1280",
      },
      {
        value: "4",
        label: "美容造型設計系",
        group: "60",
        academicSystem: "四技",
        deptmentCode: "D1120",
      },
      {
        value: "5",
        label: "幼兒保育系",
        group: "60",
        academicSystem: "四技",
        deptmentCode: "D1150",
      },
      {
        value: "11",
        label: "室內設計系",
        group: "62",
        academicSystem: "四技",
        deptmentCode: "D3060",
      },
      {
        value: "159",
        label: "時尚設計系",
        group: "62",
        academicSystem: "四技",
        deptmentCode: "D3350",
      },
      {
        value: "164",
        label: "多媒體動畫系",
        group: "62",
        academicSystem: "四技",
        deptmentCode: "D3370",
      },
      {
        value: "17",
        label: "視覺傳達設計系",
        group: "62",
        academicSystem: "四技",
        deptmentCode: "D3210",
      },
      {
        value: "18",
        label: "商品設計系",
        group: "62",
        academicSystem: "四技",
        deptmentCode: "D3040",
      },
      {
        value: "212",
        label: "漫畫系",
        group: "62",
        academicSystem: "四技",
        deptmentCode: "212",
      },
      {
        value: "19",
        label: "美術系",
        group: "63",
        academicSystem: "四技",
        deptmentCode: "D4130",
      },
      {
        value: "19",
        label: "美術系",
        group: "63",
        academicSystem: "七技",
        deptmentCode: "74130",
      },
      {
        value: "21",
        label: "舞蹈系",
        group: "63",
        academicSystem: "四技",
        deptmentCode: "D4070",
      },
      {
        value: "21",
        label: "舞蹈系",
        group: "63",
        academicSystem: "七技",
        deptmentCode: "74070",
      },
      {
        value: "213",
        label: "流行音樂系",
        group: "63",
        academicSystem: "四技",
        deptmentCode: "D4540",
      },
      {
        value: "20",
        label: "音樂系",
        group: "63",
        academicSystem: "七技",
        deptmentCode: "74050",
      },
    ],
    targetdepartlist: [],
    staff: [],
    selectedCollegeCode: "NONE",
    selectedDeptmentCode: "NONE",
    selectedPlannerCode: "NONE",
    selectedAcademicSystem: "四技",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_target_depart = (value) => {
    const result = this.state.targetdeparts.filter(function (el) {
      return el.group === value;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  api_list_deptment_planner = async (targetDepart) => {
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    const result = await req_list_ssp_target_principal(
      userCode,
      userLevel,
      targetDepart,
      token
    );
    const plannerCodes = result.total > 0 ? result.data : [];
    this.setState({ plannerCodes });
    // console.log("plannerCodes:", plannerCodes);
  };

  api_search_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_multiple_employee(key, token);
    // console.log(result);
    if (result.data === null) {
      message.success("查無此人");
    } else {
      this.setState({ staff: result.data });
    }
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_add_ssp_worker(item, token);
    this.setState({ loading: false });
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  setTargetdeparts = (value) => {
    this.api_list_target_depart(value);
  };

  setPlannerCodes = (value) => {
    this.api_list_deptment_planner(value);
  };

  // 操作互動處理 //////////////////////////////////////////////

  handleChange(event) {
    const { row } = this.state;
    Object.keys(row).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        row[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ row });
  }

  handleAcademicSystem = (value) => {
    this.setState({
      selectedAcademicSystem: value,
    });
  };

  handleCollegeChange = (value) => {
    this.setState({
      selectedCollegeCode: value,
      selectedDeptmentCode: "NONE",
      selectedPlannerCode: "NONE",
    });
    this.setTargetdeparts(value);
  };

  handleTargetdepartChange = (value) => {
    this.setState({
      selectedDeptmentCode: value,
      selectedPlannerCode: "NONE",
    });
    this.setPlannerCodes(value);
  };

  handlePlannerCodeChange = (value) => {
    this.setState({
      selectedPlannerCode: value,
    });
  };

  onSearch = (value) => {
    //console.log(value);
    if (value.length >= 1) {
      this.api_search_item(value);
    } else {
    }
  };

  onChange = (staff) => {
    const { EmployeeId } = staff;
    const {
      selectedCollegeCode,
      selectedDeptmentCode,
      selectedAcademicSystem,
      colleges,
      alldeparts,
    } = this.state;

    const errors = [];

    if (selectedCollegeCode === "NONE") {
      errors.push("學院未選");
    }

    if (selectedDeptmentCode === "NONE") {
      errors.push("系所未選");
    }

    if (selectedAcademicSystem === "NONE") {
      errors.push("學制未選");
    }

    const row = this.state.row;
    if (errors.length === 0) {
      row.CollegeCode = selectedCollegeCode;
      let CollegeFullName = colleges.filter((college) => {
        return college.value === row.CollegeCode;
      });
      row.CollegeFullName = CollegeFullName[0].label;
      row.EducationalSystemTwName = selectedAcademicSystem;
      row.DeptmentRealCode = selectedDeptmentCode;
      let targetDepart = alldeparts.filter((depart) => {
        return (
          depart.value === row.DeptmentRealCode &&
          depart.academicSystem === row.EducationalSystemTwName
        );
      });
      if (targetDepart.length > 0) {
        row.DeptmentCode = targetDepart[0].deptmentCode;
        row.DeptmentFullName = targetDepart[0].label;
        row.DeptmentPlannerCode = EmployeeId;
        //console.log(row);
        this.api_add_item(row);
      } else {
        message.error("無此學制或系所");
      }
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  };

  init_columns = () => {
    this.columns = [
      {
        title: "",
        dataIndex: "",
        render: (item) => {
          const { EmployeeId, TwName } = item;
          return (
            <>
              <>
                {EmployeeId}/{TwName}
              </>
              <Button
                type="primary"
                size="small"
                onClick={() => this.onChange(item)}
              >
                <i className="fas fa-user-cog"></i>
                <span style={{ marginLeft: "4px" }}> 接任</span>
              </Button>
            </>
          );
        },
      },
    ];
  };
  //////////////////////////////////////////////////////////

  render() {
    const {
      colleges,
      targetdepartlist,
      academicSystems,
      selectedCollegeCode,
      selectedDeptmentCode,
      selectedAcademicSystem,
      staff,
    } = this.state;

    const listTargetdeparts =
      targetdepartlist.length > 0 ? (
        <>
          {targetdepartlist.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.label}
            </Option>
          ))}
        </>
      ) : (
        ""
      );

    return (
      <Card>
        <form>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>負責學制
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleAcademicSystem}
                  defaultValue={selectedAcademicSystem}
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {academicSystems.map((college) => (
                    <Option key={college.value} value={college.value}>
                      {college.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>負責學院
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleCollegeChange}
                  defaultValue={selectedCollegeCode}
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {colleges.map((college) => (
                    <Option key={college.value} value={college.value}>
                      {college.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>負責系所
                </label>
                <Select
                  style={{ width: "100%" }}
                  onChange={this.handleTargetdepartChange}
                  defaultValue={selectedDeptmentCode}
                  allowClear
                >
                  <Option key={"NONE"} value={"NONE"}>
                    請選擇
                  </Option>
                  {listTargetdeparts}
                </Select>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-12">
              <div className="form-group">
                <label>
                  <span className="text-danger">*</span>負責人
                </label>
                <Search
                  placeholder="負責老師姓名"
                  allowClear
                  enterButton={
                    <>
                      <i className="fas fa-search"></i> 查詢
                    </>
                  }
                  size="large"
                  onSearch={this.onSearch}
                />
                <Table
                  bordered
                  scroll={{ y: 380 }}
                  dataSource={staff}
                  columns={this.columns}
                />
              </div>
            </div>
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManageWorkerAddModal);
